import app from '$$app';

export default instance => {
  const appSubscriptions = [];

  appSubscriptions.push(app.on('portfolio:ganttIDs:remove', (multiviewIds, ganttId) => {
    if (!instance.config.multiview || !multiviewIds.some(id => +id === instance.config.multiview_id)) {
      return;
    }

    const projectTasks = instance.getTaskBy(task => task.parent === 1 && task.type === instance.config.types.project && task.gantt_id === +ganttId);

    if (projectTasks[0]) {
      instance.silent(() => {
        instance.deleteTask(projectTasks[0].id);
      });
    }
  }));

  return {
    appSubscriptions,
  };
};
